export default function useTitle(title){
    document.title = title+" Guatemala | Intelaf"
}